// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/ResearchCard.tsx (`StepCheck`, L192-198; exported here so every card shares it)
import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'

/** The done mark of a step or a card: a 20px success-tinted round token with a check. */
export function StepCheck({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-5 shrink-0 items-center justify-center rounded-full bg-ds-badge-success-bg text-ds-badge-success-text',
        className,
      )}
    >
      <Check className="size-3.5" />
    </span>
  )
}
